// extracted by mini-css-extract-plugin
export default {"button":"secondary-mini__button___fDe5- primary-mini__button___jNPId primary__button___frFdc base__button___zT0JW"};